import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
//import Countdown from './Countdown';
import Button from './Buttons';
import * as firebase from 'firebase';

/**
 * Receives paused, uid, and sessionid props from OrderbookContainer
 *
 * this component deals with submitting market orders as well as
 * rendering the start button(will need to change)
 */
class MarketOrders extends Component {
    constructor(props) {
        //console.log("MarketOrder constructor " + props);
        super(props);
    }

    /**
     * checks if the market order was a Bid and sets that order to OrdersPending
     *
     *  if statements handle various checks (to validate input)
     * @param event
     */
    /* changed by Hang 09/30/18 */
    handleMarketInput = (event) => {
        //console.log("MarketOrder handleMarketKeyUp ", event);

        /* get input box value */
        let marketInput = document.getElementsByName("marketInput")[0].value;

        //console.log(marketInput);
        //console.log(event.target.innerHTML);

        let newOrderRef;
        let order;

        const ordersPendingRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("OrdersPending");

        if (marketInput != null && !isNaN(marketInput) && marketInput % 1 === 0) {
            let volumeInt = parseInt(marketInput, 10);
            if (volumeInt > 0 && volumeInt <= 999) {
                if (event.target.innerHTML === 'BUY') {
                    order = {
                        Type: "Bid",
                        Volume: volumeInt,
                        UserId: this.props.uid,
                        AssetId: "INTC",
                        Strike: null,
                        Class: "Market"

                    };
                    console.log(order);
                    newOrderRef = ordersPendingRef.push();
                    newOrderRef.set(order);
                    document.getElementsByName("marketInput")[0].value = "";
                } else {
                    //checks if the market order was a Ask and sets that order
                    //to OrdersPending
                    order = {
                        Type: "Ask",
                        Volume: volumeInt,
                        AssetId: "INTC",
                        UserId: this.props.uid,
                        Strike: null,
                        Class: "Market"
                    };
                    //console.log(order);
                    newOrderRef = ordersPendingRef.push();
                    newOrderRef.set(order);
                    document.getElementsByName("marketInput")[0].value = "";
                }
            } else {
                alert("You must enter a number between 0 and 999");
                document.getElementsByName("marketInput")[0].value = "";
            }
        } else {
            alert("You must enter a valid whole number");
            document.getElementsByName("marketInput")[0].value = "";
        }

    };

    /**
     * checks to see if the game is paused and
     * sets paused state to true or false
     */
    componentWillReceiveProps(nextProps) {
    }

    /**
     * based on the paused state, will disable the input for market orders
     * @returns {*}
     */
    render() {
        //console.log("MarketOrder render");
        return (
            <div className='market-orders'>

                {/* Changed by Hang, to market-activity-container  9/30/18 */}
                <div className='market-activity-container'>
                    <button
                        onClick={this.handleMarketInput}
                        disabled={this.props.paused}>BUY</button>
                    <input
                        disabled={this.props.paused}
                        type="text"
                        size="4"
                        name="marketInput"
                        className={'marketInputEl'}
                        autoComplete="off"
                    />
                    <button
                        onClick={this.handleMarketInput}
                        disabled={this.props.paused}>SELL</button>
                </div>
            </div>
        );
    }
}

MarketOrders.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string
};

export default MarketOrders;



// WEBPACK FOOTER //
// ./src/components/Orderbook/MarketOrders.js